import React from "react";
import "./footer.css";
import { footer } from "../../data/Data";

function Footer() {
  return (
    <>
      <section className="footerContact">
        <div className="container">
          <div className="send flex">
            <div className="text">
              <h1>Do You Have Questions ?</h1>
            </div>
            <a href="tel:+918169633015" className="btn5">
              Contact Us Today
            </a>
          </div>
        </div>
      </section>
      <footer>
        <div className="container">
          <div className="box">
            <div className="logo">
              <img src="../images/logo.png" alt=""  />
              <h2>Do You Need Help With Anything?</h2>
              <p>Contact us now at .. +91 8169633015</p>
            </div>
          </div>
        </div>
      </footer>
      <div className="legal">
        <span>
          © 2024 A.K Properties Nashik. Designed By disojakaran@gmail.com.
        </span>
      </div>
    </>
  );
}

export default Footer;
